import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader, Badge } from "@/components/Kit";

const inr = (n) => "₹" + (n || 0).toLocaleString("en-IN");
const PLAN_COLOR = { basic: "#06B6D4", standard: "#4F46E5", premium: "#F59E0B" };

export default function Revenue() {
  const { data } = useQuery({
    queryKey: ["sa-revenue"],
    queryFn: async () => (await api.get("/superadmin/revenue")).data,
  });
  const rows = data?.rows || [];
  const totalSub = rows.reduce((a, r) => a + r.subscription, 0);
  const totalFee = rows.reduce((a, r) => a + r.fee_collection, 0);

  return (
    <div data-testid="revenue-page">
      <PageHeader title="Revenue Report" subtitle="Subscription income + fee collection per school" />

      <div className="mb-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
        <div className="ep-card p-5"><p className="text-xs uppercase text-slate-400">Subscription Revenue</p><p className="mt-2 text-2xl font-bold font-head text-emerald-400">{inr(totalSub)}</p></div>
        <div className="ep-card p-5"><p className="text-xs uppercase text-slate-400">Fee Collection (all schools)</p><p className="mt-2 text-2xl font-bold font-head text-indigo-400">{inr(totalFee)}</p></div>
        <div className="ep-card p-5"><p className="text-xs uppercase text-slate-400">Total Platform Revenue</p><p className="mt-2 text-2xl font-bold font-head text-amber-400">{inr(totalSub + totalFee)}</p></div>
      </div>

      <div className="ep-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-800 text-left text-xs uppercase tracking-wider text-slate-500">
                <th className="px-4 py-3">School</th>
                <th className="px-4 py-3">Plan</th>
                <th className="px-4 py-3 text-right">Subscription</th>
                <th className="px-4 py-3 text-right">Fee Collection</th>
                <th className="px-4 py-3">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} className="border-b border-slate-800/50 hover:bg-slate-800/30" data-testid={`revenue-row-${i}`}>
                  <td className="px-4 py-3 font-medium text-white">{r.school}</td>
                  <td className="px-4 py-3"><Badge color={PLAN_COLOR[r.plan]}>{r.plan}</Badge></td>
                  <td className="px-4 py-3 text-right text-slate-300">{inr(r.subscription)}</td>
                  <td className="px-4 py-3 text-right text-slate-300">{inr(r.fee_collection)}</td>
                  <td className="px-4 py-3 capitalize text-slate-400">{r.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
